export default __webpack_public_path__ + "static/sustainability_soy_based-1132d72100ad5c39c331628a413babf9.svg";